export default __webpack_public_path__ + "static/media/firebase.214266d8.png";